import client from "@/libs/client.ts";
import type { Ledger } from "@/types/account";
import type { LedgerResource } from "@/factories/LedgerFactory.ts";

const create = async (ledger: Omit<Ledger, "id" | "colour">): Promise<LedgerResource> => {
  const response = await client.post(`account/ledgers`, ledger);

  if (response.status !== 201) {
    throw new Error(response.statusText);
  }

  return response.data.data;
};

const fetchAll = async (): Promise<LedgerResource[]> => {
  const response = await client.get(`account/ledgers`);

  if (response.status !== 200) {
    throw new Error(response.statusText);
  }

  return response.data.data;
};

export { create, fetchAll };
